(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crown-aegis-quality-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){var open=event.target.closest('[data-report-open]');if(open){var dialog=document.querySelector('[data-report-dialog="'+open.getAttribute('data-report-open')+'"]');if(dialog&&dialog.showModal)dialog.showModal();return}var close=event.target.closest('[data-report-close]');if(close){var dialog=close.closest('dialog');if(dialog)dialog.close()}});document.querySelectorAll('.ca-q-report-dialog').forEach(function(dialog){dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
